import { Form, Input } from "decorator-form";

import { ID } from "common/entities/IEntity";
import { EntityMultiSelect } from "common/form/fields/entitySelect/EntityMultiSelect";
import EntitySelect from "common/form/fields/entitySelect/EntitySelect";
import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import { Entity, Field } from "typegraph";

const typeSelect = ButtonSelect.registerWithOptions([
	{value: 'one', label: "One Only"},
	{value: 'many', label: "Multi Select"},
	{value: 'onePerSet', label: "One Per Tag Set"}
]);

const entityTypeSelect = ButtonSelect.registerWithOptions([
	{value: 'all', label: 'All'},
	{value: 'item', label: 'Courses'},
	{value: 'article', label: 'Articles'}
]);

// tslint:disable:max-classes-per-file
@Entity({many: "tagSets"})
class TagSet {
	@Field() public id: string;
	@Field() public name: string;
}

const tagSetSelect = EntitySelect.registered({entity: TagSet, type: 'many'}, 'string');

@Form({title: "Refine Tag Panel Config"})
export default class RefineTagPanelConfig {

	@Input({type: typeSelect, title: "Tag Selection"})
	public tagSelection?: 'one' | 'many' | 'onPerSet';

	@Input({type: InputType.CHECKBOX, title: "Bundle Tags Only"})
	public bundleTags?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Show Active Tags List"})
	public showActiveTags?: boolean;

	@Input({type: tagSetSelect, title: "Tag Sets"})
	public tagSets?: ID[];

	@Input({type: InputType.CHECKBOX, title: "Force Tag Set Order (ignore sort index field)"})
	public sortTagSets?: boolean;

	@Input({type: entityTypeSelect, title: "Tag Set Targets"})
	public target?: "all" | "article" | "item";

	@Input({type: InputType.CHECKBOX, title: "Show AND/OR tag condition control"})
	public showTagConditionControl: boolean;

}



// WEBPACK FOOTER //
// ./src/panels/refineTag/RefineTagPanelConfig.ts